
import Address from './components/Address';
import Auth from './support/Auth';
import Basket from './components/Basket';
import BasketModel from './models/Basket';
import currency from './support/Currency';
import Date from './components/utilities/Date';
import Intersect from './directives/Intersect';
import List from './components/utilities/List';
import Navigation from './components/includes/Navigation';
import Overlay from './components/Overlay';
import Pagination from './components/Pagination';
import Reveal from './components/Reveal';
import router from './routes';
import Upload from './components/Upload';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use( VueRouter );
Vue.directive( 'lazy-load', Intersect );

Vue.component( 'basket', Basket );
Vue.component( 'date', Date );
Vue.component( 'list', List );
Vue.component( 'navigation', Navigation );
Vue.component( 'pagination', Pagination );
Vue.component( 'reveal', Reveal );
Vue.component( 'reveal-overlay', Overlay );
Vue.component( 'upload', Upload );
Vue.component( 'user-address', Address );

function boot()
{
	new Vue({
		data: {
			auth: Auth,
			basketOpen: false,
		},
		computed:
			{
				displayBasket()
				{
					return this.basketOpen && this.$route.name !== 'checkout';
				},
				basket()
				{
					return this.auth.basket;
				}
			},
		el: '#app',
		methods:
			{
				toggleBasket()
				{
					this.basketOpen = !this.basketOpen;
				},
				openBasket()
				{
					this.basketOpen = true;
				},
				closeBasket()
				{
					this.basketOpen = false;
				},
				currency,
			},
		router,
	});
}

Promise.all([
	Auth.restore(),
	BasketModel.restore(),
]).then( boot, boot );
